export class InvoicePdfDto {
  static fromApi(res) {
    return {
      data: res.data,
      filename: retrieveFileNameFromHeaders(res.headers),
      contentType: res.headers["content-type"],
    };
  }
}

const retrieveFileNameFromHeaders = (headers) => {
  const contentDisposition = headers["content-disposition"];
  let filename = "invoice.pdf";

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) {
      filename = match[1];
    }
  }
  return filename;
};
